<template lang="pug">
.flex.items-start.flex-wrap
    
    .block(class="lg:w-12/12 lg:pl-8 p-0 w-full")
        .block(class="lg:py-4 p-4")
            
            .flex.items-center.justify-between
                .field.mr-2.relative.field--search
                    span Found {{ search_by_name_paspor && search_by_name_paspor.content ? search_by_name_paspor.content.length : 0 }} data
                
        .table-static.w-full
            table
                thead
                    tr
                        th(v-for="(th, index) in tableThead" :key="index")
                            | {{ th.name }}
                tbody
                    tr(v-if="load_data_status_search_by_name_paspor === 'loading'")
                        td.text-center(:colspan="tableThead.length")
                            .flex.flex-wrap.items-center.justify-center
                                Spinner(show="true" size="48")

                    template(v-else-if="search_by_name_paspor && search_by_name_paspor.data && search_by_name_paspor.data != 'not found' && search_by_name_paspor.data.length > 0")
                        tr(v-for="(data, index) in search_by_name_paspor.data" :key="index")
                            td {{ data.nomor_dokumen_perjalanan ? data.nomor_dokumen_perjalanan : '-'}}
                            td {{ data.nama_depan ? data.nama_depan : '-'}} {{ data.nama_belakang ? data.nama_belakang : '-'}}
                            td {{ data.tanggal_perlintasan ? data.tanggal_perlintasan : '-'}}
                            td {{ data.arah_perlintasan ? data.arah_perlintasan : '-'}}
                            td {{ data.nama_tpi ? data.nama_tpi : '-'}}
                            td {{ data.kode_alat_angkut || data.desc_alat_angkut ? data.kode_alat_angkut +' '+ data.desc_alat_angkut : ''}}
                            
                            td 
                                button.btn-primary(
                                    @click="viewData(data)"
                                ) View

                    tr(v-else)
                        td.text-center(:colspan="tableThead.length") No Data Available
    
    section(v-if="selectedData").section-popup.section-popup--show.fixed.w-full-h.full.inset-0.flex.items-start.justify-center
        .section-popup__container
            .box
                .box__header.no-border
                    header.flex.items-center.justify-between
                        .header-meta
                            div.flex.items-center
                                span.text-light.name-index {{ selectedData.nama_lengkap }}
                        .header-cta
                            button.btn-icon.btn-icon-40(v-on:click="viewData()")
                                .icon-btn
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                .box__body.p-4
                    .mb-12.grid.gap-x-12.gap-y-4.grid-cols-2
                        .block.mb-4
                            span.block.mb-2.text-light Paspor Number
                            h3.font-normal {{ selectedData.nomor_dokumen_perjalanan ? selectedData.nomor_dokumen_perjalanan : '-'}}
                        .block.mb-4
                            span.block.mb-2.text-light Document Type ID
                            h3.font-normal {{ selectedData.jenis_dokumen_perjalanan ? selectedData.jenis_dokumen_perjalanan : '-'}}
                        .block.mb-4
                            //- span.block.mb-2.text-light Issued Date
                            //- h3.font-normal {{ selectedData.tanggal_dikeluarkan ? selectedData.tanggal_dikeluarkan : '-'}}
                            span.block.mb-2.text-light Crossing Date
                            h3.font-normal {{ selectedData.tanggal_perlintasan ? selectedData.tanggal_perlintasan : '-'}}   
                        .block.mb-4
                            span.block.mb-2.text-light Crossing Status
                            h3.font-normal {{ selectedData.status_perlintasan ? selectedData.status_perlintasan : '-'}}                          
                        .block.mb-4
                            //- span.block.mb-2.text-light Nikimin Number
                            //- h3.font-normal {{ selectedData.no_nikim ? selectedData.no_nikim : '-'}}
                            span.block.mb-2.text-light Crossing Direction Code
                            h3.font-normal {{ selectedData.kode_arah_perlintasan ? selectedData.kode_arah_perlintasan : '-'}}
                        .block.mb-4
                            //- span.block.mb-2.text-light Old Paspor Number
                            //- h3.font-normal {{ selectedData.no_paspor_lama ? selectedData.no_paspor_lama : '-'}}
                            span.block.mb-2.text-light Crossing Direction
                            h3.font-normal {{ selectedData.arah_perlintasan ? selectedData.arah_perlintasan : '-'}}
                        .block.mb-4
                            span.block.mb-2.text-light Gender
                            h3.font-normal {{ selectedData.kode_jenis_kelamin ? selectedData.kode_jenis_kelamin : '-'}}
                        .block.mb-4
                            span.block.mb-2.text-light Expiry Date
                            h3.font-normal {{ selectedData.tanggal_akhir_berlaku_dokumen_perjalanan ? selectedData.tanggal_akhir_berlaku_dokumen_perjalanan : '-'}}
                        .block.mb-4
                            span.block.mb-2.text-light Transport Code
                            h3.font-normal {{ selectedData.kode_alat_angkut ? selectedData.kode_alat_angkut : '-'}}
                        .block.mb-4
                            span.block.mb-2.text-light Transport Description
                            h3.font-normal {{ selectedData.desc_alat_angkut ? selectedData.desc_alat_angkut : '-'}}
                        .block.mb-4
                            span.block.mb-2.text-light DOB
                            h3.font-normal {{ selectedData.tanggal_lahir ? selectedData.tanggal_lahir : '-'}}
                        .block.mb-4
                            span.block.mb-2.text-light Nationality
                            h3.font-normal {{ selectedData.kode_kewarganegaraan ? selectedData.kode_kewarganegaraan : '-'}}
                        .block.mb-4
                            span.block.mb-2.text-light Full Name
                            h3.font-normal {{ selectedData.nama_depan ? selectedData.nama_depan : '-'}} {{ selectedData.nama_belakang ? selectedData.nama_belakang : '-'}} 
                        .block.mb-4
                            span.block.mb-2.text-light Residence address
                            h3.font-normal {{ selectedData.alamat_domisili ? selectedData.alamat_domisili : '-'}}
                        .block.mb-4
                            span.block.mb-2.text-light Name on Passport
                            h3.font-normal {{ selectedData.nama_depan ? selectedData.nama_depan : '-'}} {{ selectedData.nama_belakang ? selectedData.nama_belakang : '-'}} 
                        .block.mb-4
                            span.block.mb-2.text-light Register Number
                            h3.font-normal {{ selectedData.register_no ? selectedData.register_no : '-'}}
                        //- .block.mb-4
                        //-     span.block.mb-2.text-light Profession
                        //-     h3.font-normal {{ selectedData.pekerjaan ? selectedData.pekerjaan : '-'}}
                        //- .block.mb-4
                        //-     span.block.mb-2.text-light Phone Number
                        //-     h3.font-normal {{ selectedData.no_hp ? selectedData.no_hp : '-'}}
                        //- .block.mb-4
                        //-     span.block.mb-2.text-light Application Code
                        //-     h3.font-normal {{ selectedData.kode_permohonan ? selectedData.kode_permohonan : '-'}}                        


</template>

<script>
import { mapState } from 'vuex';
import { encrypt,decrypt } from '@/util/crypto';
import VueAdsPagination, { VueAdsPageButton } from 'vue-ads-pagination';
import '../../../node_modules/vue-ads-pagination/dist/vue-ads-pagination.css';
import Spinner from '@/components/Spinner.vue';

export default {
    name: 'SourcePaspor',
    components: {
        Spinner,
        VueAdsPagination,
        VueAdsPageButton,
    },
    data(){
        return {
            filterShow: false,

            tableThead: [
                {
                    name: 'Paspor Number',
                }
                ,{
                    name: 'Full Name',
                }
                ,{
                    name: 'Date',
                }
                ,{
                    name: 'Direction',
                }
                ,{
                    name: 'Name of TPI',
                }
                ,{
                    name: 'Description',
                }                
                ,{
                    name: 'Action',
                }
            ],
            keyword: '',
            data_result: [],

            // pagination
            total_data: 0,
            items_per_page: 10,

            size: [10, 25, 50, 100],

            page: 0,
            start: 0,
            end: 0,

            // for filter
            gender: '',
            // year_of_birth_data: '',
            age_min: '',
            age_max: '',

            filter_gender: ['L', 'P'],
            timeout: null,

            selectedData: null,
        }
    },
    computed: {
        ...mapState([
            'load_data_status_search_by_name_paspor',
            'search_by_name_paspor',
        ]),
        route_name() {
            return this.$route.name;
        },
        key() {
            return this.$route.params.key;
        },
        isKey() {
            // return this.key!==undefined ? true : false;
            return this.key ? true : false;
        },
    },
    watch: {
        route_name(newData, oldData) {
            if (newData === 'PageName') {
                if (oldData !== 'PageName') {
                    this.items_per_page = 10;
                    this.page = 0;
                    // this.keyword = '';
                    // this.$store.commit('setSearchByNamePaspor', {});
                }
                // this.getData();
            }
        },
        key() {
            // if (this.route_name === 'PageName')
            this.gender = '';
            this.age_min = '';
            this.age_max = '';

            // this.page = 0;
            // this.getData(true);
            this.$store.commit('setSearchByNamePaspor', []);
        },
        isKey() {},
        breadcrumb() {},

        search_by_name_paspor(newData) {
            console.log({newData})
            let dataContent = newData.content ? newData : [] 
            if (dataContent.length > 0) {
                this.total_data = parseInt(dataContent);
                // this.page = (parseInt(newData.current_page) - 1);
            }
        },
        total_data() {
            // this.pagination();
        },
        items_per_page() {
            this.getData();
            // this.pagination();
        },
        page() {
            this.getData();
        },
        gender() {},
        age_min() {},
        age_max() {},
    },
    methods: {
        encrypt(key, type) {

            // remove space in prefix
            if (key.substr(0, 1) === ' ')
                key = key.substr(1, (key.length - 1));

            if (type === 'msisdn') {

                let prefix_key = key.substr(0, 1);

                if (prefix_key === 0 || prefix_key === '0') {
                    key = '62' + key.substr(1, (key.length - 1));
                } else if (key.substr(0, 4) === '+620') {
                    key = '62' + key.substr(4, (key.length - 4));
                } else if (prefix_key === '+') {
                    key = key.substr(1, (key.length - 1));
                }
            }

            return encrypt(key + '&&' + type);
        },
        async getData(filter=false) {
            if (this.route_name === 'PageName' ) {
                if (this.isKey) {

                    if (filter)
                        this.page = 0;

                    let decrypt_data = decrypt(this.key);
                    decrypt_data = decrypt_data.split('&&');

                    var key = decrypt_data[0];
                    // var type = decrypt_data[1];

                    this.keyword = key;

                    // gender='', age_min='', age_max=''

                    await this.$store.dispatch('getSearchByNamePaspor', [key, this.items_per_page, (this.page + 1), this.gender, this.age_min, this.age_max]);
                
                    this.pagination();
                    
                } else {
                    this.$store.commit('setSearchByNamePaspor', []);
                }                
            }
        },
        reset() {

            this.$swal.fire({
                icon: 'warning',
                title: 'Are you sure you want to reset?',
                // text: 'Role : ' + name,
                confirmButtonText: 'Yes!',
                confirmButtonColor: '#DD6B55',
                showCancelButton: true,
                allowOutsideClick: false,
            })
            .then((result) => {
                // console.log('on result');
                if (result.isConfirmed) {
                    this.gender = '';
                    // this.year_of_birth_data = '';
                    this.age_min = '';
                    this.age_max = '';

                    this.getData(true);
                }
            });

        },
        // pagination
        pageChange(page) {
            this.page = page;
        },
        rageChange(start, end) {
            this.start = start;
            this.end = end;
        },
        sizeChange() {
            this.page = 0;
        },
        pagination() {
            // update fontawesome to iconfont
            var paginationButtonPreview = document.getElementsByClassName("fa-angle-left");

            if (paginationButtonPreview[0]) {
                var classListPrev = paginationButtonPreview[0].classList;

                if (Object.values(classListPrev).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonPreview[0].classList.add('iconfont');
                    paginationButtonPreview[0].classList.add('iconleft');
                    paginationButtonPreview[0].style.fontSize = '12px';
                }
            }

            var paginationButtonNext = document.getElementsByClassName("fa-angle-right");

            if (paginationButtonNext[0]) {
                var classListNext = paginationButtonNext[0].classList;

                if (Object.values(classListNext).filter(key => ['iconfont'].includes(key)).length === 0) {
                    paginationButtonNext[0].classList.add('iconfont');
                    paginationButtonNext[0].classList.add('iconright');
                    paginationButtonNext[0].style.fontSize = '12px';
                }
            }
        },
        showLoading(show=true) {
            if (show) {
                this.$swal.fire({
                    title: '',
                    html: '<div class="save_loading"><svg viewBox="0 0 140 140" width="140" height="140"><g class="outline"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="rgba(0,0,0,0.1)" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"></path></g><g class="circle"><path d="m 70 28 a 1 1 0 0 0 0 84 a 1 1 0 0 0 0 -84" stroke="#71BBFF" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-dashoffset="200" stroke-dasharray="300"></path></g></svg></div><div><h4>Loading...</h4></div>',
                    showConfirmButton: false,
                    allowOutsideClick: false
                });

            } else {
                this.$swal.close();
            }
        },
        viewData(data=null) {
            this.selectedData= data
        },
    },
    mounted() {
        // console.log('on paspor')
        EventEmit.$on('openSearchByNamePaspor', () => {
            // console.log('on openSearchByNamePaspor')
            // this.getData();
            if (this.page !== 0) {
                this.page = 0;
            } else {
                this.getData();
            }
        });
    },
}
</script>